
import Vue from 'vue'
import { mapGetters } from 'vuex'
import vuescroll from 'vuescroll'
import _ from 'lodash'

const handleChangeScrollByProperty = (vm: any): void => {
  const value = vm.scrollBy
  if (value.dx || value.dy) {
    vm.$refs.scrollComponent.scrollBy(value)
    vm.$emit('onManualMove')
    setTimeout(() => {
      debouncedHandleChangeScrollByProperty(vm)
    }, 50)
  }
}

const debouncedHandleChangeScrollByProperty = _.debounce(handleChangeScrollByProperty, 100)

export default Vue.extend({
  name: 'scrollComponent',
  props: {
    isMain: {
      type: Boolean
    },
    onlyHorizontal: {
      type: Boolean
    },
    onlyVertical: {
      type: Boolean
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    y: {
      type: Boolean
    },
    x: {
      type: Boolean
    },
    scrollBy: {
      type: Object,
      default: () => ({
        dx: 0,
        dy: 0
      })
    },
    scrollTo: {
      type: Object,
      default: () => ({
        x: 0,
        y: 0
      })
    }
  },
  data: () => ({
    shiftKey: false,
    ops: {
      vuescroll: {
        mode: 'native',
        sizeStrategy: 'percent',
        detectResize: true,
        wheelScrollDuration: 400,
        checkShifKey: true,
        zooming: false
      },
      scrollPanel: {
        speed: 100,
        easing: 'easeOutQuad',
        initialScrollY: 0,
        initialScrollX: 0,
        scrollingX: false,
        scrollingY: false
      },
      bar: {
        showDelay: 500,
        onlyShowBarOnScroll: false,
        keepShow: true,
        background: 'rgba(255, 255, 255, 0.545)',
        opacity: 1,
        hoverStyle: false,
        specifyBorderRadius: false,
        minSize: 0.2,
        size: '2px'
      },
      rail: {
        background: '#2C2C2C',
        opacity: 1,
        size: '12px',
        gutterOfEnds: null,
        gutterOfSide: '2px',
        keepShow: false
      },
      scrollButton: {
        enable: true,
        background: 'rgba(255, 255, 255, 0.5442)',
        opacity: 1,
        step: 50,
        mousedownStep: 30
      }
    },
    process: 0,
    scrollState: {
      top: 0,
      left: 0
    },
    counter: 0,
    removeScrollTimeout: null,
    isInited: false
  }),
  computed: {
    ...mapGetters('popupModule', ['getPopupIsOpened'])
  },
  watch: {
    scrollBy: {
      handler (): void {
        const vm = this as any
        debouncedHandleChangeScrollByProperty(vm)
      },
      deep: true
    },
    scrollTo: {
      handler (newState): void {
        this.$refs.scrollComponent.scrollTo(newState, 400, 'linear')
      },
      deep: true
    },
    process (v: number): void {
      this.$emit('changePosition', v)
    },
    getPopupIsOpened (v: boolean): void {
      if (this.isMain) {
        const { scrollComponent } = (this as any).$refs
        this.ops.scrollPanel.scrollingY = !v
        scrollComponent.refresh()
      }
    }
  },
  methods: {
    handleResize (eventY: any, eventX: any) {
      this.scrollState.top = eventY.scrollTop
      this.scrollState.left = eventX.scrollLeft
    },
    handleScroll (eventY: any, eventX: any): void {
      this.scrollState.top = eventY.scrollTop
      this.scrollState.left = eventX.scrollLeft
      const vm = this as any
      if (vm.isMain) {
        if (eventY.scrollTop > 0) {
          document.body.classList.add('scrolled')
        } else document.body.classList.remove('scrolled')
      }
      this.process = eventY.process
      const { scrollComponent } = (this as any).$refs
      scrollComponent.$el.classList.add('scrolling')
      if (this.removeScrollTimeout === null) {
        (this as any).removeScrollTimeout = setTimeout(() => {
          scrollComponent.$el.classList.remove('scrolling')
          this.removeScrollTimeout = null
        }, 1000)
      }
      if (this.process > 0 && this.process < 1) this.counter = 0
    },
    onMouseWheel (event: WheelEvent): void {
      const vm = this as any
      const { scrollComponent } = (this as any).$refs
      if (!this.onlyHorizontal) {
        if (vm.counter < 2) event.preventDefault()
        vm.counter++
      } else {
        event.preventDefault()
        event.stopPropagation()
        scrollComponent.scrollBy({ dx: event.deltaY })
      }
    }
  },
  created (): void {
    const vm = this as any
    const computeX = (): boolean => {
      if (vm.onlyVertical) return false
      if (vm.onlyHorizontal) return true
      return vm.x
    }
    const computeY = (): boolean => {
      if (vm.onlyHorizontal) return false
      if (vm.onlyVertical) return true
      return vm.y
    }
    vm.ops.bar.disable = vm.isDisabled
    vm.ops.scrollPanel.scrollingX = computeX()
    vm.ops.scrollPanel.scrollingY = computeY()
  },
  mounted (): void {
    const vm = this as any
    const { scrollComponent } = vm.$refs
    window.addEventListener('resize', () => {
      scrollComponent.refresh()
    })
    if (!scrollComponent.scrollYEnable) this.$emit('changePosition', 1)
  },
  components: {
    vueScroll: vuescroll
  }
})
